export const FILTER_CONTROL_BASE_CLASS =
    "rounded-lg border border-border bg-card text-sm font-normal text-secondary-foreground shadow-none";

export const FILTER_CONTROL_INTERACTIVE_CLASS = `${FILTER_CONTROL_BASE_CLASS} transition-colors hover:border-border hover:bg-tertiary hover:text-secondary-foreground`;

export const FILTER_CONTROL_MUTED_ICON_CLASS = "shrink-0 text-muted-foreground";

export const FILTER_TOGGLE_ITEM_CLASS = `h-8 rounded-full border bg-card px-2.5 text-xs font-normal text-secondary-foreground shadow-none
hover:border-border hover:bg-accent hover:text-secondary-foreground
data-[state=on]:border-border data-[state=on]:bg-primary-foreground/70 data-[state=on]:text-blue-700`;

export const ASSET_CLASS_CATEGORY_ITEM_CLASS =
    "inline-flex items-center justify-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-semibold outline-none transition-colors focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1";
